<template>
<div>
  <Grid name="filterGridProdAgreg" ref="filterGridProdAgreg" v-bind:url="url" v-bind:columns="columns" :pageable='true' :height="height" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:preload="preload"></Grid>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import kendo from '@progress/kendo-ui/js/kendo.all.js'
export default {
  name: 'ProdAgreg',
  props: ['height'],
  components: {
    Grid
  },
  data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'prodagregs',
      columns: [{
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-success',
          text: 'incluir',
          click: this.addIncludeFilter
        }
      }, {
        'title': '',
        width: '120px',
        command: {
          'className': 'btn btn-danger',
          text: 'excluir',
          click: this.addExcludeFilter
        }
      }, {
        width: '160px',
        field: 'code',
        title: 'Código'
      }, {
        field: 'name',
        title: 'Name',
        width: '200px'
      }],
      loaded: false,
      tableInitialized: false,
      variables: [],
      rows: [],
      subrows: [],
      filters: [],
      tables: []
    }
  },
  methods: {
    addIncludeFilter(e) {
      e.preventDefault()
      console.log('click', window.performance.now())
      var grid = this.$refs.filterGridProdAgreg.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      console.log('emit', window.performance.now())
      this.$emit('added-filter', {
        field: 'product_aggregator_id',
        item: dataItem,
        title: 'Prodagreg',
        'type': 'includes'
      })
    },
    addExcludeFilter(e) {
      e.preventDefault()
      var grid = this.$refs.filterGridProdAgreg.$refs.mygrid.kendoWidget()
      var dataItem = grid.dataItem(kendo.jQuery(e.currentTarget).closest('tr'))
      this.$emit('added-filter', {
        field: 'product_aggregator_id',
        item: dataItem,
        title: 'Prodagreg',
        'type': 'excludes'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProdAgregFilter.vue?170736bc